import { ExportToExcel } from '@/services/excel/generator/excelGenerator';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import ColumnExcel from '@/services/excel/generator/columnExcel';

export const columns = [
  new ColumnExcel('Code dispositif', 'codeDispositif', true),
  new ColumnExcel('Url de l\'image', 'url', true),
  new ColumnExcel('Pour Logo', 'isLogo', true),
];

export function templateConfig(data, nameFile, newColumns) {
  return new ExportExcel(`${nameFile || 'TemplateLogoDispositif'}.xlsx`, [
    new SheetExcel('Logo dispositif', newColumns || columns, data,
      { skipHeader: false },
    ),
  ]);
}

export function generatedTemplateBonStock() {
  const exemple = {};
  const config = templateConfig([exemple]);
  ExportToExcel(config);
}

export function generatedTemplateLogoDispositif() {
  const exemple = {
    codeDispositif: 'CODE-D',
    url: 'https://www.affixe-logiciel.fr/wp-content/uploads/sites/3/2021/11/affixe_accueil.png',
    isLogo: 'Oui',
  };
  const config = templateConfig([exemple], 'TemplateLogoDispositif');
  ExportToExcel(config);
}
